/*
 * This data is used by notification.js
 * 
 * Enqueue this file before notifications.js
 * 
 * Each notification object should have a title and body text
 * 
 */

 export const notifications = {
    login: {
        title : 'Login',
        body : 'You have successfully logged in.'
    }, 
    logout: {
        title : 'Log Out',
        body : 'You have successfully logged out.'
    },
	corporatesubscribed: {
        title : 'Subscribed',
        body : 'You have a active corporate subscription.'
    }
	
 }

 export default notifications;